//
import { setInstance, type DataDogRum } from './instance';

export { setExperiments, logAction, setUser, log } from './api';
export { DataDogRum };

export { logExceptionOnce, logUnknownErrorResponse } from './exception-logging';

export function init(datadogRum: DataDogRum) {
  setInstance(datadogRum);
}

export { initialize as initializeLogger } from './instance';

export { initSentry } from './sentry';

export { workmagic } from './workmagic';
